<template>
  <div class="contract-agreement-wrap">
    <cooperation-search-head
      :showBg="true"
      placeholder="请输入合同名称/合同编号"
      :showMenu="false"
      @handSearch="handSearch"
    >
    </cooperation-search-head>
    <div>
      <div class="contract-agreement-info">
        <cooperation-detail-head-cp
          v-show="sticky"
          :mainContract="false"
        ></cooperation-detail-head-cp>
      </div>
      <div class="contract-agreement-title">
        <cooperation-title-cp
          title="全部补充协议"
          :bg="false"
        ></cooperation-title-cp>
      </div>
      <div class="contract-agreement-list">
        <van-list
          :offset="30"
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell v-for="(item, index) in list" :key="index">
            <template>
              <div class="mine-item">
                <mine-contract-change
                  :item="item"
                  :mainContract="mainContract"
                  :showContractAgreement="false"
                ></mine-contract-change>
              </div>
              <div class="mine-item-bg"></div>
            </template>
          </van-cell>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import cooperationSearchHead from './cooperation-packge/components/cooperation-search-head-cp';
import cooperationTitleCp from '../components/title-cp';
import mineContractChange from './cooperation-packge/components/cooperation-my-contract-change-cp';
import cooperationDetailHeadCp from './cooperation-packge/components/cooperation-detail-head-cp';
import { Sticky, List, PullRefresh } from 'vant';
import { getUrlParams } from 'common/js/mUtils';
export default {
  components: {
    cooperationSearchHead,
    cooperationTitleCp,
    mineContractChange,
    cooperationDetailHeadCp,
    [Sticky.name]: Sticky,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  data() {
    return {
      loading: false,
      finished: true,
      refreshing: false,
      list: [],
      sticky: true,
      contractguid: '',
      mainContract: '',
      watertext: '',
      watermobile: ''
    };
  },
  created() {
    let { contractguid, mainContract } = this.$route.query;
    let { employeeName, mobile } = getUrlParams();
    this.watertext = decodeURIComponent(employeeName) || '';
    this.watermobile = mobile;
    this.mainContract = mainContract;
    this.contractguid = contractguid;
    this._getContractRepairInfos({ contractguid });
  },
  methods: {
    handSearch(data) {
      let { contractguid } = this;
      data = Object.assign({}, data, { contractguid });
      this._getContractRepairInfos(data);
    },
    _getContractRepairInfos(params) {
      this.$api.getContractRepairInfos(params).then(res => {
        let { body } = res;
        if (res.status) {
          this.list = body;
        }
      });
    },
    onLoad() {}
  }
};
</script>

<style lang="scss" scoped>
.contract-agreement-wrap {
  // background: #efefef;
  position: relative;
  z-index: 9;
  .contract-agreement-info {
    margin-top: 24px;
    background: transparent;
  }
  .contract-agreement-title {
    position: relative;
    margin-top: 20px;
  }
  .contract-agreement-list {
    background-color: transparent;
    // height: 600px;
    position: relative;
    /deep/ .van-cell {
      position: relative;
      display: flex;
      box-sizing: border-box;
      width: 100%;
      padding: 0px;
      overflow: hidden;
      color: #323233;
      font-size: 0.28rem;
      line-height: 1;
      background-color: transparent;
      margin-bottom: 10px;
    }
  }
  .contract-agreement-title::after {
    position: absolute;
    content: '';
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 1px;
    background: #efefef;
  }
  .mine-item-bg {
    background: #efefef;
    height: 10px;
  }
}
</style>
